const initialState = {
  data: {
    data: '',
    dzienWiodacy: '',
    fakultety: [],
    kodProduktu: '',
    uzytkownicy: []
  },
  fetching: false,
  last_fetch: null
};

export default function (state = initialState, action) {
  switch(action.type) {
    case 'FETCH_SCHEDULE_REQUEST':
      return Object.assign({}, state, { fetching: true });
    case 'FETCH_SCHEDULE_SUCCESS':
      return Object.assign({}, state, { data: action.payload, fetching: false, last_fetch: new Date().getTime() });
    case 'FETCH_SCHEDULE_FAILURE':
      return Object.assign({}, state, { fetching: false });
    default:
      return state;
  }
}
